{
  "title": "Leomund's Tiny Hut",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level evocation (ritual)",
  "level": 3,
  "castingTime": "1 minute",
  "range": "Self (10-foot-radius hemisphere)",
  "components": "V, S, M (a small crystal bead)",
  "duration": "8 hours",
  "description": [
    "A 10-foot-radius immobile dome of force springs into existence around and above you and remains stationary for the duration. The spell ends if you leave its area.",
    "Nine creatures of Medium size or smaller can fit inside the dome with you. The spell fails if its area includes a larger creature or more than nine creatures. Creatures and objects within the dome when you cast this spell can move through it freely. All other creatures and objects are barred from passing through it. Spells and other magical effects can't extend through the dome or be cast through it. The atmosphere inside the space is comfortable and dry, regardless of the weather outside.",
    "Until the spell ends, you can command the interior to become dimly lit or dark. The dome is opaque from the outside, of any color you choose, but it is transparent from the inside."
  ],
  "spellLists": ["bard", "eldritch-knight", "wizard"]
}
